import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

import CreateEnterprisePayload from '@enterprise/models/dto/enterprise-create.dto';
import IOption from '@models/option';
import { modeType } from '@models/mode';

interface CreateEnterpriseContextData {
  stepIndex: number;
  setStepIndex: Dispatch<SetStateAction<number>>;
  payload: CreateEnterprisePayload | undefined;
  setPayload: Dispatch<SetStateAction<CreateEnterprisePayload | undefined>>;
  sectors: IOption[] | undefined;
  setSectors: Dispatch<SetStateAction<IOption[] | undefined>>;
  mode: modeType;
  setMode: Dispatch<SetStateAction<modeType>>;
  isAddressFormValid: boolean | undefined;
  setIsAddressFormValid: Dispatch<SetStateAction<boolean | undefined>>;
  isDetailsFormValid: boolean | undefined;
  setIsDetailsFromValid: Dispatch<SetStateAction<boolean | undefined>>;
  isDirty: boolean;
  setIsDirty: Dispatch<SetStateAction<boolean>>;
}

export const CreateEnterpriseContext = createContext<
  CreateEnterpriseContextData | undefined
>(undefined);

const CreateEnterpriseProvider = ({ children }: { children: ReactNode }) => {
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [payload, setPayload] = useState<CreateEnterprisePayload>();
  const [mode, setMode] = useState<modeType>('create');
  const [isDetailsFormValid, setIsDetailsFromValid] = useState<
    boolean | undefined
  >(true);
  const [isAddressFormValid, setIsAddressFormValid] = useState<
    boolean | undefined
  >(true);

  // only for UI
  const [sectors, setSectors] = useState<IOption[] | undefined>([]);

  const [isDirty, setIsDirty] = useState(false);

  useEffect(() => {
    if (
      payload?.addressDto?.cityId === '' ||
      payload?.addressDto?.cityId === undefined
    ) {
      setPayload((prevPayload) => {
        const updatedPayload = { ...prevPayload };
        if (updatedPayload.addressDto) {
          delete updatedPayload.addressDto.cityId;
        }
        return updatedPayload;
      });
    }
  }, [payload?.addressDto]);

  const contextValue = useMemo(
    () => ({
      stepIndex,
      setStepIndex,
      payload,
      setPayload,
      sectors,
      setSectors,
      mode,
      setMode,
      isAddressFormValid,
      isDetailsFormValid,
      setIsAddressFormValid,
      setIsDetailsFromValid,
      isDirty,
      setIsDirty,
    }),
    [
      stepIndex,
      payload,
      sectors,
      mode,
      isAddressFormValid,
      isDetailsFormValid,
      isDirty,
    ],
  );

  return (
    <CreateEnterpriseContext.Provider value={contextValue}>
      {children}
    </CreateEnterpriseContext.Provider>
  );
};

export default CreateEnterpriseProvider;
